import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AnimatedBackgroundView from '../../common/AnimatedBackgroundView';
import StoreSwitchView from './StoreSwitchView';
import StoreCreationWizardView from '../wizard/StoreCreationWizardView';

const MerchantStoresView = () => (
  <AnimatedBackgroundView>
    <Routes>
      <Route element={<StoreSwitchView />} path="/switch" />
      <Route element={<StoreCreationWizardView />} path="/create" />
      <Route
        element={<Navigate replace to="/merchant/stores/switch" />}
        path="*"
      />
    </Routes>
  </AnimatedBackgroundView>
);

export default MerchantStoresView;
